import { ObjectDefinitionInput, ObjectFieldInput } from './fields/_parseFields';

// for back compatibility
export type { ObjectDefinitionInput };
export type BacklandObjectDefinition = ObjectDefinitionInput;
export type FieldDefinitionConfig = ObjectFieldInput;
